import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  cardNumber: Yup.string().required("Card details are required."),
  expiryDate: Yup.string().required("Card details are required."),
  cvc: Yup.string().required("Card details are required."),
});

export default validationSchema;
